const controlsWithPositionedLabel = Array.from(document.querySelectorAll('.js-form-group--has-positioned-label .js-form-control'));

if (controlsWithPositionedLabel && controlsWithPositionedLabel.length > 0) {
  controlsWithPositionedLabel.forEach(function(control) {
    control.addEventListener('focus', function (event) {
      let parentElement = control.closest('.form-group--has-positioned-label');
      parentElement.classList.remove('form-control-is-empty');
    });
    control.addEventListener('blur', function (event) {
      checkFormControlsInput(event.target);
    });
    checkFormControlsInput(control);
  });
}

function checkFormControlsInput(control) {
    if (control.value === '') {
      let parentElement = control.closest('.form-group--has-positioned-label');
      parentElement.classList.add('form-control-is-empty');
    }
}
